import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import FormGroup from './FormGroup'
import FileItem from './FileItem'

export default
class FileInput
  extends Component {

  static propTypes = {
    accept: PropTypes.string,
    className: PropTypes.string,
    descriptionPlaceholder: PropTypes.string,
    disabled: PropTypes.bool,
    index: PropTypes.number,
    info: PropTypes.string,
    item: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    note: PropTypes.string,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    renderChildren: PropTypes.func,
    value: MobXPropTypes.observableArray
  }

  static defaultProps = {
    value: []
  }

  constructor(props) {
    super(props)
    this.state = {
      files: props.value || []
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.files) {
      this.setState({
        files: nextProps.value || []
      })
    }
  }

  publishChange() {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: this.state.files
        }
      })
    }
  }

  @autobind
  handleRemove({ target: { index } }) {
    this.setState((oldState) => ({
      files: [
        ...oldState.files.slice(0, index),
        ...oldState.files.slice(index + 1),
      ]
    }), () => {
      this.publishChange()
    })
  }

  @autobind
  handleFileChange(e) {
    e.preventDefault()
    e.stopPropagation()
    const { target: { files } } = e

    const file = files[0]

    if (file.type.indexOf('image') > -1) {
      const reader = new FileReader()
      const that = this
      reader.onload = ({ target: { result } }) => {
        const fileMatch = that.state.files
          .find((f) => f.file === file)
        if (fileMatch) {
          const index = that.state.files.indexOf(fileMatch)
          fileMatch.dataURL = result
          that.setState({
            files: [
              ...that.state.files.slice(0, index),
              fileMatch,
              ...that.state.files.slice(index + 1)
            ]
          }, () => {
            this.publishChange()
          })
        }

      }
      reader.readAsDataURL(file)
    }

    const state = {
      files: [
        ...this.state.files,
        {
          file,
          name: file.name
        }
      ]
    }

    this.setState(state, () => {
      this.publishChange()
    })
  }

  @autobind
  handleFileDetailsChange({ target: { index, data } }) {

    const currentFile = {
      ...this.state.files[index],
      ...data,
      file: this.state.files[index].file,
    }

    this.setState({
      files: [
        ...this.state.files.slice(0, index),
        currentFile,
        ...this.state.files.slice(index + 1),
      ]
    }, () => {
      this.publishChange()
    })
  }

  render() {
    const {
      onChange,
      info,
      note,
      accept,
      name,
      label,
      value,
      descriptionPlaceholder,
      className,
      renderChildren,
      disabled
    } = this.props

    return (
      <FormGroup
        onChange={onChange}
        name={name}
        label={label}
        info={info}
        note={note}
      >
        <div className="col-xs-8">
          <div id="file-input">
            <input
              className="input-file form-control"
              type="file"
              name={name}
              accept={accept}
              id={name}
              value=""
              onChange={this.handleFileChange}
              disabled={disabled}
            />
          </div>

          <ul className={`file-list ${className}`}>
            {this.state.files
              .filter((item) => item.id
                || (item.file
                  && item.file instanceof File
                  && !!item.file.name))
              .map((item, index) => {
                return (
                  <FileItem
                    onRemove={this.handleRemove}
                    descriptionPlaceholder={descriptionPlaceholder}
                    key={item.id || (item.file && item.file.name)}
                    index={index}
                    item={item}
                    all={value}
                    onChange={this.handleFileDetailsChange}
                    disabled={disabled}
                    renderChildren={renderChildren}
                  />
                )
              })}
          </ul>
        </div>
      </FormGroup>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/FileInput.js